export enum ActionTypes {
    SET_COMPANIES_LIST = 'setCompaniesList',
    SET_COMPANIES_LIST_PAGE = "setCompaniesListPage",
    SET_COMPANIES_LIST_PER_PAGE = "setCompaniesListPerPage",
    SET_COMPANIES_LIST_SORT = "setCompaniesListSort",
    SET_COMPANIES_LIST_FILTER = "setCompaniesListFilter",
    SET_COMPANIES_COMPANY_CHANGE_STATUS = "setCompaniesCompanyChangeStatus",
    SET_COMPANIES_COMPANY_DELETE= "setCompaniesCompanyDelete",
    SET_COMPANIES_COMPANY_CREATE= "setCompaniesCompanyCreate",
    SET_COMPANIES_COMPANY_CHANGE_NAME = "setCompaniesCompanyChangeName",
    SET_COMPANIES_SELECTED_COMPANY = "setCompaniesSelectedCompany",
    SET_COMPANIES_SELECTED_COMPANY_WITH_USERS_LIST = "setCompaniesSelectedCompanyWithUsersList",
    SET_COMPANIES_SELECTED_COMPANY_CLEAR = "setCompaniesSelectedCompanyClear"
}